import React from "react";
import "./App.css";
import Router from "./routes/Router";

const App = () => {
  return <Router />;
};

export default App;
